import MediaLibraryGallery from './MediaLibraryGallery';

export default MediaLibraryGallery;
